var map = {
	"./LabelsBlock/LabelsBlock": [
		1962,
		962
	],
	"./LabelsBlock/LabelsBlock.jsx": [
		1962,
		962
	],
	"./LabelsBlock/LabelsBlock.module.scss": [
		2889,
		889
	],
	"./PlainTextBlock/PlainTextBlock": [
		9654,
		654
	],
	"./PlainTextBlock/PlainTextBlock.jsx": [
		9654,
		654
	],
	"./PlainTextBlock/PlainTextBlock.module.scss": [
		1976,
		976
	],
	"./TextListBlock/TextListBlock": [
		7640
	],
	"./TextListBlock/TextListBlock.jsx": [
		7640
	],
	"./TextListBlock/TextListBlock.module.scss": [
		506
	],
	"./TitleTextBlock/TitleTextBlock": [
		7540,
		540
	],
	"./TitleTextBlock/TitleTextBlock.jsx": [
		7540,
		540
	],
	"./TitleTextBlock/TitleTextBlock.module.scss": [
		1415,
		415
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3690;
module.exports = webpackAsyncContext;